import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/validators/page.tsx");
